<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title">
        {{ $translate('orders') | capitalize }}
      </h1>
      <div class="level first-level">
        <div class="level-left">
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button slot="trigger" :disabled="tableOptions.loading" type="is-primary" icon-right="printer" />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="openPrintModal()"
              >
                {{ $translate('print') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                :disabled="tableOptions.loading"
                type="button is-primary"
                icon-right="content-copy"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length != 1 || isClosed() != 1 || userInfo.type != 'A'"
                @click="openCopyOrder(tableOptions.checkedRows[0])"
              >
                {{ $translate('copy_order') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button slot="trigger" type="is-primary" :disabled="tableOptions.loading" icon-right="attachment" />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="
                  if (!tableOptions.loading && tableOptions.checkedRows.length != 0) {
                    exportJsonArray()
                  }
                "
              >
                {{ $translate('json') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="
                  if (!tableOptions.loading && tableOptions.checkedRows.length != 0) {
                    sendJsonArrayToMercurio()
                  }
                "
              >
                {{ $translate('send_to_mercurio') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="
                  if (!tableOptions.loading && tableOptions.checkedRows.length != 0) {
                    getAttachment()
                  }
                "
              >
                {{ $translate('download_attach') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="
                  if (!tableOptions.loading && tableOptions.checkedRows.length != 0) {
                    //printCSV(tableOptions.checkedRows)
                    getCSV(tableOptions.checkedRows)
                  }
                "
              >
                {{ $translate('csv_download') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="
                  if (!tableOptions.loading && tableOptions.checkedRows.length != 0) {
                    exportPdfTable()
                  }
                "
              >
                {{ $translate('pdf_download') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                type="is-primary"
                class="button is-primary"
                :disabled="tableOptions.loading"
                icon-right="pencil-outline"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="isTrackingNumberDisabled()"
                @click="
                  if (!isTrackingNumberDisabled()) {
                    trackcodechangemodal()
                  }
                "
              >
                {{ $translate('track_numbe_change') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length == 0"
                @click="
                  if (tableOptions.checkedRows.length != 0) {
                    massivemercurioidchangemodal()
                  }
                "
              >
                {{ $translate('edit_mercury_id') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length == 0"
                @click="
                  if (tableOptions.checkedRows.length != 0) {
                    massiveDeliveryDateChangeModal()
                  }
                "
              >
                {{ $translate('edit_delivery_date') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length == 0"
                @click="
                  if (tableOptions.checkedRows.length != 0) {
                    massiveUpdateSearchArray()
                  }
                "
              >
                {{ $translate('update_search_array') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                type="is-primary"
                class="button is-primary"
                :disabled="tableOptions.loading"
                icon-right="send-outline"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="!hasSameStatus()"
                @click="
                  if (hasSameStatus()) {
                    changeStatus('invord')
                  }
                "
              >
                {{ $translate('save_envo') }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="
                  if (!tableOptions.loading && tableOptions.checkedRows.length != 0) {
                    markAsPrinted()
                  }
                "
              >
                {{ $translate('save_printed') }}
              </b-dropdown-item>
              <b-dropdown-item class="pointercursor linktype">
                {{ $translate('save_sended') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                type="is-primary"
                class="button is-primary"
                :disabled="tableOptions.loading"
                icon-right="format-list-bulleted"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                @click="
                  isSwitched = 0
                  searchData()
                "
              >
                {{ $translate('actives') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                @click="
                  isSwitched = 1
                  searchData()
                "
              >
                {{ $translate('closeds') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                @click="
                  isSwitched = 2
                  searchData()
                "
              >
                {{ $translate('cestino') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-field :label="$translate('startdate') | capitalize" label-position="on-border" expanded>
              <b-datepicker
                v-model="startdate"
                :disabled="tableOptions.loading"
                size="is-small"
                :placeholder="$translate('startdate')"
                icon="calendar-today"
                :date-formatter="date => new Intl.DateTimeFormat('it-IT').format(date)"
                :date-parser="
                  date => {
                    let dateArray = date.split(/[.//-]/)
                    return new Date(`${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`)
                  }
                "
                editable
                locale="it-IT"
                @input="searchData()"
              >
                <button
                  class="button is-danger"
                  @click="
                    startdate = null
                    searchData()
                  "
                >
                  <b-icon icon="close" />
                  <span>{{ $translate('delete') }}</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="level-item">
            <b-field :label="$translate('enddate') | capitalize" label-position="on-border" expanded>
              <b-datepicker
                v-model="enddate"
                :disabled="tableOptions.loading"
                size="is-small"
                :placeholder="$translate('enddate')"
                icon="calendar-today"
                :date-formatter="date => new Intl.DateTimeFormat('it-IT').format(date)"
                :date-parser="
                  date => {
                    let dateArray = date.split(/[.//-]/)
                    return new Date(`${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`)
                  }
                "
                editable
                locale="it-IT"
                @input="searchData()"
              >
                <button
                  class="button is-danger"
                  @click="
                    enddate = null
                    searchData()
                  "
                >
                  <b-icon icon="close" />
                  <span>{{ $translate('delete') }}</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="level-right">
          <b-input
            v-model="queryString"
            :disabled="tableOptions.loading"
            :placeholder="$translate('search').concat('...') | capitalize"
            type="search"
            icon="magnify"
            @keyup.native.enter="searchData"
          />
        </div>
      </div>
      <div class="level second-level">
        <div class="level-left">
          <div class="level-item">
            <p class="is-size-5 has-text-primary">
              {{ $translate('filter') | capitalize }}
            </p>
          </div>
          <div class="level-item">
            <filter-select
              v-model="orderTypeFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="orderTypeMainFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="deliverySelectedFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="statusOrderFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="moduleFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <p class="is-size-5 has-text-primary">
              {{ $translate('changeStatus') | capitalize }}
            </p>
          </div>
          <div class="level-item">
            <b-field :label="$translate('status') | capitalize" label-position="on-border">
              <b-select v-model="statusSelected" size="is-small">
                <template v-for="status in statusavailable">
                  <option :key="status" :value="status">
                    {{ $translate(status) }}
                  </option>
                </template>
              </b-select>
            </b-field>
          </div>
          <div class="level-item">
            <b-button
              size="is-small"
              :disabled="!hasSameStatus()"
              class="is-primary"
              @click="changeStatus() /*groupChangeStatus()*/"
            >
              {{ $translate('confirm') }}
            </b-button>
          </div>
        </div>
      </div>
      <b-table
        ref="mainTable"
        :sticky-header="true"
        :data="tableData"
        :narrowed="true"
        :checked-rows.sync="tableOptions.checkedRows"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        :backend-sorting="true"
        checkable
        detailed
        :default-sort="[field, order]"
        :row-class="(row, index) => evaluateRowClass(row)"
        :is-row-checkable="row => !row.claim"
        hoverable
        @sort="sortPressed"
        @check="multipleSelectionIconManage"
      >
        <template slot-scope="props">
          <b-table-column
            field="send_date"
            :label="$translate('send_date') | capitalize"
            :sortable="allShops && allCompanies"
          >
            <template
              v-if="props.row.send_date && new Date(props.row.send_date).toLocaleDateString() != 'Invalid Date'"
            >
              {{ new Date(props.row.send_date).toLocaleDateString() }}
            </template>
            <template v-else>
              -
            </template>
          </b-table-column>
          <b-table-column field="id_mercury" :label="$translate('id_mercury') | capitalize">
            {{ props.row.id_mercury }}
          </b-table-column>
          <b-table-column field="company.id" :label="$translate('company') | capitalize">
            <a
              v-if="props.row.company"
              @click="
                $router.push({
                  name: 'companies',
                  params: { companyId: props.row.company.id },
                })
              "
              >{{ props.row.company ? props.row.company.name : '' }}</a
            >
            <template v-else />
          </b-table-column>
          <b-table-column field="patient.id" :label="$translate('patient') | capitalize">
            <a
              v-if="props.row.patient"
              @click="
                $router.push({
                  name: 'patients',
                  params: { patientId: props.row.patientId },
                })
              "
            >
              {{
                `${props.row.patient.name} ${props.row.patient.surname}
              ${props.row.patient.alias}`
              }}
            </a>
            <template v-else />
          </b-table-column>
          <b-table-column field="orderType" :label="$translate('orderType') | capitalize" sortable>
            {{ `${$translate(props.row.orderType)}` }}
          </b-table-column>
          <b-table-column field="orderTypeMain" :label="$translate('orderTypeMain') | capitalize" sortable>
            {{ `${$translate(props.row.orderTypeMain)}` }}
          </b-table-column>
          <b-table-column field="deliverySelected" :label="$translate('deliverySelected') | capitalize" sortable>
            {{ `${$translate(props.row.deliverySelected)}` }}
          </b-table-column>
          <b-table-column field="module" :label="$translate('module') | capitalize" sortable>
            <b-tag
              v-if="evaluateRowClass(props.row) !== 'is-claim'"
              class="module-tag"
              :type="
                props.row.module
                  ? $moduleConfiguration[props.row.module].tagColor
                  : $moduleConfiguration['tailored'].tagColor
              "
              >{{ $translate(props.row.module ? props.row.module : 'tailored') }}</b-tag
            >
          </b-table-column>
          <b-table-column field="statusOrder" :label="$translate('status') | capitalize" sortable>
            {{ $translate(props.row.statusOrder) ? $translate(props.row.statusOrder) : $translate(props.row.status) }}
          </b-table-column>
          <b-table-column field="isPrinted" :label="$translate('isPrinted') | capitalize" centered>
            <b-icon v-if="!props.row.claim && props.row.isPrinted" icon="check" type="is-success" />
          </b-table-column>
          <!--INIZIO COLONNA ACTIONS-->
          <b-table-column :label="$translate('action') | capitalize">
            <!--INIZIO AZIONI CLAIM-->
            <template v-if="props.row.claim">
              <b-dropdown aria-role="list" position="is-bottom-left">
                <b-icon slot="trigger" class="has-text-primary" icon="menu-down" />
                <!--AZIONI SE IL CLAIM è STATO CONFERMATO-->
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="!amIClaimSender(props.row.AdminClaim) || props.row.status !== 'saved'"
                  @click="
                    $router.push({
                      name: 'editClaim',
                      params: {
                        orderid: props.row.orderid,
                        id: props.row.id,
                      },
                    })
                  "
                >
                  {{ $translate('edit') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="
                    amIClaimSender(props.row.AdminClaim) ||
                      (props.row.status !== 'sent' && props.row.status !== 'responseSaved')
                  "
                  @click="
                    props =>
                      $router.push({
                        name: 'newResponsetoClaim',
                        params: {
                          claimid: props.row.id,
                          orderid: props.row.orderid,
                        },
                      })
                  "
                >
                  {{ $translate('response_claim') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  @click="
                    $router.push({
                      name: 'Claim',
                      params: {
                        orderid: props.row.orderid,
                        id: props.row.id,
                      },
                    })
                  "
                >
                  {{ $translate('view_claim') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="!isClaimDeletable(props.row)"
                  @click="deleteOccurenceClaim(props.row.orderid, props.row.id)"
                >
                  {{ $translate('delete') | capitalize }}
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <!--INIZIO AZIONI ORDINI-->
            <template v-else>
              <b-dropdown aria-role="list" position="is-bottom-left">
                <b-icon slot="trigger" class="has-text-primary" icon="menu-down" />
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="isEditDoable(props.row.statusOrder) == false"
                  @click="
                    $router.push({
                      name: 'editOrder',
                      params: {
                        orderId: props.row.id,
                        view: true,
                        module: props.row.module,
                      },
                    })
                  "
                >
                  {{ $translate('edit') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="isMercuryEditable() == false"
                  @click="mercurioidchangemodal(props.row)"
                >
                  {{ $translate('edit_mercury_id') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="isTransitionDoable(props.row.statusOrder, 'deletedord', props.row) == false"
                  @click="deleteOccurence(props.row.id)"
                >
                  {{ $translate('delete') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  :disabled="isClaimDoable(props.row.statusOrder) === false"
                  @click="
                    $router.push({
                      name: 'newClaim',
                      params: { orderid: props.row.id, module: props.row.module },
                    })
                  "
                >
                  {{ $translate('claim') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  @click="
                    $router.push({
                      name: 'editOrder',
                      params: { orderId: props.row.id, view: false, module: props.row.module },
                    })
                  "
                >
                  {{ $translate('view') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item class="pointercursor" aria-role="listitem" @click="viewHistory(props.row)">
                  {{ $translate('history') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item class="pointercursor" aria-role="listitem" @click="updateSearchArray(props.row)">
                  {{ $translate('update_search_array') | capitalize }}
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <!--<PrintOrder
              :ref="'PrintOrder' + props.row.primaryCode"
              :order.sync="props.row"
            ></PrintOrder>-->
          </b-table-column>
          <!--FINE COLONNA ACTIONS-->
        </template>
        <template slot="detail" slot-scope="props">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <template v-if="!props.row.claim">
                    <strong>{{ $translate('shop') | capitalize }}:</strong>
                    <a
                      v-if="props.row.shop.id"
                      @click="
                        $router.push({
                          name: 'shops',
                          params: { shopId: props.row.shop.id },
                        })
                      "
                      >{{ props.row.shop.name }}</a
                    >
                    <template v-else />
                    <br />
                  </template>
                  <strong>{{ $translate('primaryCode') | capitalize }}:</strong>
                  {{ props.row.primaryCode }}
                  <br />
                  <strong>{{ $translate('secondaryCode') | capitalize }}:</strong>
                  {{ props.row.secondaryCode }}
                  <br />
                  <strong>{{ $translate('technician') | capitalize }}:</strong>
                  {{ props.row.tec }}
                  <br />
                  <template v-if="props.row.claim">
                    <template v-if="props.row.answer">
                      <strong>{{ $translate('answer_date') | capitalize }}:</strong>
                      {{ new Date(props.row.answercreationDate).toLocaleDateString() }}
                      - {{ props.row.answertec }}
                      <br />
                    </template>
                    <template v-if="props.row.confirmed">
                      <strong>{{ $translate('check_date') | capitalize }}:</strong>
                      {{ new Date(props.row.DateCheck).toLocaleDateString() }}
                      -
                      {{ props.row.Checktec }}
                    </template>
                  </template>
                  <template v-else>
                    <strong>{{ $translate('orderTypeMain') | capitalize }}:</strong>
                    {{ $translate(props.row.orderTypeMain) }}
                    <template v-if="props.row.orderTypeVariant">
                      , {{ $translate(props.row.orderTypeVariant) }}
                    </template>
                    <template v-if="props.row.orderTypeSubVariant">
                      ,
                      {{ $translate(props.row.orderTypeSubVariant) }}
                    </template>
                    <br />
                    <strong>{{ $translate('deliverySelected') | capitalize }}:</strong>
                    {{ $translate(props.row.deliverySelected) }}
                    <template v-if="props.row.deliverySelectedSub">
                      ,
                      {{ $translate(props.row.deliverySelectedSub) }}
                    </template>
                    <br />
                    <strong>{{ $translate('track_numbe') | capitalize }}:</strong>
                    {{ $translate(props.row.track_number) }}
                    <br />
                    <strong>{{ $translate('expectedDeliveryDate') | capitalize }}:</strong>
                    {{
                      props.row.deliveryDate == undefined ? '-' : new Date(props.row.deliveryDate).toLocaleDateString()
                    }}
                    <template v-for="(claim, index) in props.row.claims">
                      <br
                        v-if="!props.row.claims[index].deleted && props.row.claims[index].status == 'confirmed'"
                        :key="claim"
                      />
                      <a
                        v-if="!props.row.claims[index].deleted && props.row.claims[index].status == 'confirmed'"
                        :key="claim"
                        :class="{
                          'has-text-danger': claim.inadequate,
                        }"
                        @click="
                          $router.push({
                            name: 'Claim',
                            params: { orderid: props.row.id, id: index, module: props.row.module },
                          })
                        "
                      >
                        R_{{ props.row.primaryCode }}_CLAIM_{{ ('0000' + (parseInt(index) + 1)).substr(-4, 4) }}
                      </a>
                    </template>
                  </template>
                </p>
              </div>
            </div>
          </article>
        </template>
        <template v-if="!disableRequestMore" slot="footer">
          <b-button expanded @click="appendData()">
            <b-icon icon="arrow-down-thick" />
          </b-button>
        </template>
        <template slot="empty">
          <section v-if="!tableOptions.loading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
    <b-modal :active.sync="massivetrackingmodal" :width="640" scroll="keep">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('track_numbe') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <table class="table">
            <thead>
              <th>{{ $translate('primaryCode') | capitalize }}</th>
              <th>ex-{{ $translate('track_numbe') | capitalize }}</th>
              <th>{{ $translate('id_mercury') | capitalize }}</th>
              <th>{{ $translate('track_numbe') | capitalize }}</th>
            </thead>
            <tbody>
              <tr v-for="currentorder in massivecurrentorderid" :key="currentorder.id">
                <td>{{ $translate(currentorder.primaryCode) }}</td>
                <td>{{ $translate(currentorder.track_number) }}</td>
                <td>{{ $translate(currentorder.id_mercury) }}</td>
                <td>
                  <b-input v-model="newtrack_number" :value="currentorder.track_number" maxlength="20" />
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="massivetrackingmodal = false">
            Close
          </button>
          <button class="button is-primary" @click="massivechangeTrack()">
            {{ $translate('track_numbe') | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal :active.sync="massiveDeliveryDateModal" :width="640" scroll="keep">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('edit_delivery_date') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body" style="min-height: 400px">
          <table class="table" style="width: 100%">
            <thead>
              <th>{{ $translate('send_date') | capitalize }}</th>
              <th>{{ $translate('primaryCode') | capitalize }}</th>
              <th>{{ $translate('id_mercury') | capitalize }}</th>
            </thead>
            <tbody>
              <tr v-for="currentorder in massivecurrentorderid" :key="currentorder.id">
                <td>
                  <b-datepicker
                    v-model="currentorder.tempDeliveryDate"
                    icon="calendar-today"
                    editable
                    :date-parser="
                      date => {
                        var d = new Date(Date.parse(date))
                        if (date == d.toLocaleString()) {
                          return d
                        } else {
                          var month = d.getMonth()
                          d.setMonth(d.getDate() - 1)
                          d.setDate(month + 1)
                          return d
                        }
                      }
                    "
                  />
                </td>

                <td>{{ $translate(currentorder.primaryCode) }}</td>
                <td>{{ $translate(currentorder.id_mercury) }}</td>
              </tr>
            </tbody>
          </table>
        </section>

        <footer class="modal-card-foot">
          <button class="button" type="button" @click="massiveDeliveryDateModal = false">
            Close
          </button>
          <button class="button is-primary" @click="massiveChangeDeliveryDate()">
            {{ $translate('edit_delivery_date') | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>

    <b-modal id="massivemercurioidmodal" :active.sync="massivemercurioidmodal" :width="640" scroll="keep">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $translate('edit_mercury_id') | capitalize }}
          </p>
        </header>
        <section class="modal-card-body">
          <table class="table">
            <thead>
              <th>{{ $translate('customer') | capitalize }}</th>
              <th>{{ $translate('primaryCode') | capitalize }}</th>
              <th>{{ $translate('id_mercury') | capitalize }}</th>
            </thead>
            <tbody>
              <tr v-for="currentorder in massivecurrentorderid" :key="currentorder.id">
                <td>{{ $translate(currentorder.company.name) }}</td>
                <td>{{ $translate(currentorder.primaryCode) }}</td>
                <td>
                  <b-input v-model="currentorder.tempid_mercury" maxlength="8" />
                </td>
              </tr>
            </tbody>
          </table>
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="massivemercurioidmodal = false">
            Close
          </button>
          <button class="button is-primary" @click="massivechangeMercurioid()">
            {{ $translate('edit_mercury_id') | capitalize }}
          </button>
        </footer>
      </div>
    </b-modal>

    <PrintOrder :print-order-bool.sync="printOrderBool" :orders.sync="printOrders" />
    <HistoryOrderModal :history-modal-bool.sync="historyModalBool" :history-order.sync="historyOrder" />
  </section>
</template>

<script>
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import orderTools from '@/helpers/mixins/orderTools'
import exportTools from '@/helpers/mixins/exportTools'
import firebase from 'firebase'
import filterSelect from '@/components/FilterSelect'
import PrintOrder from '@/views/Orders/components/PrintOrder'
import HistoryOrderModal from '@/views/Orders/components/HistoryOrderModal'

import JSZip from 'jszip'
import saveAs from 'file-saver'
//import request from "request";
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'

export default {
  name: 'InternalOrders',
  components: {
    'filter-select': filterSelect,
    PrintOrder: PrintOrder,
    HistoryOrderModal: HistoryOrderModal,
  },
  mixins: [mainMixin, permissionMixin, keyWordGenerator, orderTools, exportTools],
  data() {
    return {
      statusdenied: [],
      statusavailable: [],
      field: 'statusOrder',
      order: 'asc',
      queryString: '',
      shops: [],
      AllshopsId: [],
      AllStatus: [],
      AlldeliverySelected: [],
      AllorderType: [],
      AllorderTypeMain: [],
      //indici sorting
      statusIndex: 0,
      companiesindex: 0,
      shopindex: 0,
      deliveryindex: 0,
      orderTypeindex: 0,
      orderTypeMainindex: 0,
      mainQuery: this.$db.collection('orders'),
      lastRequested: null,
      disableRequestMore: true,
      limit: 20,
      massivemercurioidmodal: false,
      massivetrackingmodal: false,
      massiveDeliveryDateModal: false,
      massivecurrentorderid: [],
      statusSelected: this.$status['tailored'][0],
      isSwitched: 0,
      startdate: null,
      newtrack_number: null,
      enddate: null,
      statusIndexjump: 10,
      historyModalBool: false,
      historyOrder: null,
      printOrderBool: false,
      printOrders: null,
      orderTypeFilterInfo: {
        label: 'orderType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      orderTypeMainFilterInfo: {
        label: 'orderTypeMain',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      deliverySelectedFilterInfo: {
        label: 'deliveryType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      statusOrderFilterInfo: {
        label: 'status',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      moduleFilterInfo: {
        label: 'module',
        options: [{ name: '*' }],
        filterValue: '*',
      },

      patientFilter: undefined,
    }
  },
  mounted() {
    switch (this.userInfo.type) {
      case 'A':
        break
      case 'I':
        if (this.userInfo.level === '1') {
          this.statusdenied = ['invord', 'compord']
        }
        break
      case 'C':
        break
      default:
        this.$router.push('/forbidden')
        break
    }
    for (let status in this.$status['tailored']) {
      if (!this.statusdenied.includes(this.$status['tailored'][status])) {
        this.statusavailable.push(this.$status['tailored'][status])
        this.AllStatus.push(this.$status['tailored'][status])
      }
    }

    this.statusSelected = this.statusavailable[0]

    let filtersStatus = this.$store.state.filters.internalOrders
    if (this.$route.params.patientId) {
      this.setFilterValues(
        filtersStatus.type,
        filtersStatus.typeMain,
        filtersStatus.delivery,
        filtersStatus.status,
        this.$route.params.patientId,
        filtersStatus.text,
        filtersStatus.module
      )
    }

    this.loadData()
  },
  methods: {
    openCopyOrder(order) {
      if (order.company.bdictionary == 'B2' && order.statusOrder != 'compord' && order.module !== 'fits') {
        this.$router.push({
          name: 'simplifiedCopyOrder',
          params: {
            orderIdToCopy: order.id,
          },
        })
      } else {
        this.$router.push({
          name: 'copyOrder',
          params: {
            orderIdToCopy: order.id,
          },
        })
      }
    },
    evaluateRowClass(row) {
      if (row.claim) return 'is-claim'
      if (row.haveclaimsAdmin) return 'has-claim'
      if (row.statusOrder == 'invord') return 'is-invord'
      if (row.statusOrder == 'sendord') return 'is-sendord'
      if (row.statusOrder == 'workord') return 'is-workord'
      if (row.statusOrder == 'standord') return 'is-standord'
      if (row.statusOrder == 'endord') return 'is-endord'
      if (row.statusOrder == 'waitord') return 'is-waitord'
      if (row.statusOrder == 'invord') return 'is-invord'
    },
    isClosed() {
      let order = 0
      this.tableOptions.checkedRows.forEach(row => {
        if (
          !row.claim &&
          (row.statusOrder == 'closed' || row.statusOrder == 'processed' || row.statusOrder == 'compord')
        ) {
          order += 1
        }
      })
      return order
    },
    openPrintModal() {
      this.printOrderBool = true
      this.printOrders = this.tableOptions.checkedRows
    },
    viewHistory(rowhistory) {
      this.historyOrder = rowhistory
      this.historyModalBool = true
      this.$forceUpdate()
    },
    sortPressed(field, order) {
      this.enddate = null
      this.startdate = null
      switch (field) {
        case 'statusOrder':
          this.AllStatus.reverse()
          break
        case 'deliverySelected':
          this.AlldeliverySelected.reverse()
          break
        case 'orderType':
          this.AllorderType.reverse()
          break
        case 'orderTypeMain':
          this.AllorderTypeMain.reverse()
          break
      }

      this.field = field
      this.order = order
      this.searchData()
    },
    NotClaim() {
      let order = 0
      this.tableOptions.checkedRows.forEach(row => {
        if (!row.claim) {
          order += 1
        }
      })
      return order
    },
    /*async resaveall() {
      await this.$db
        .collection("orders")
        .get()
        .then(docs => {
          docs.forEach(async doc => {
            let newOrder = doc.data();
            newOrder.id = doc.id;
            if (newOrder.statusOrder == "deletedord") {
              newOrder.deleted = true;
            } else {
              if (newOrder.statusOrder != "draft") {
                newOrder.deleted = false;
              }
            }

            await this.$db
              .collection("orders")
              .doc(newOrder.id)
              .update(newOrder)
              .then();
          });
        });
    },*/
    /*async getAttachment() {
      const cloneDeep = require("clone-deep")
      this.tableOptions.loading = true
      var zip = new JSZip()
      for (let order of this.tableOptions.checkedRows) {
        for (let item in order.attachment) {
          console.log(item)
        }
      }
    },*/
    async getAttachment() {
      //this.isSaveDisabled = true;
      const cloneDeep = require('clone-deep')
      this.tableOptions.loading = true
      var zip = new JSZip()
      for (let row in this.tableOptions.checkedRows) {
        for (var item in this.tableOptions.checkedRows[row].attachment) {
          if (this.tableOptions.checkedRows[row].attachment[item] != null) {
            if (this.tableOptions.checkedRows[row].attachment[item].name) {
              //
            } else {
              let oldmeta = ''
              const storageRef = this.$storage.ref(
                'order/attachment/' + this.tableOptions.checkedRows[row].id + '/' + item
              )

              await storageRef.getMetadata().then(metadata => {
                oldmeta = metadata.contentType
              })
              if (item.substring(item.length - 6, item.length - 3) == 'pln') {
                oldmeta = 'pln'
              } else if (item.substring(item.length - 6, item.length - 3) == 'fms') {
                oldmeta = 'fms'
              } else if (item.substring(item.length - 6, item.length - 3) == 'stl') {
                oldmeta = 'stl'
              } else if (item.substring(item.length - 6, item.length - 3) == 'una') {
                oldmeta = 'stl'
              } else if (oldmeta.includes('zip')) {
                oldmeta = 'zip'
              } else {
                oldmeta = oldmeta.substr(oldmeta.length - 3)
                if (oldmeta == 'peg') {
                  oldmeta = 'jpeg'
                }
              }
              await storageRef.getDownloadURL().then(async url => {
                await fetch(url).then(async htmlReturn => {
                  let previousChunk = new Uint8Array()
                  let fileArray = new Uint8Array()
                  const reader = htmlReturn.body.getReader()
                  await reader
                    .read()
                    .then(function appendStreamChunk({ done, value }) {
                      if (value) {
                        previousChunk = cloneDeep(fileArray)
                        fileArray = new Uint8Array(previousChunk.length + value.length)
                        fileArray.set(previousChunk)
                        fileArray.set(value, previousChunk.length)
                      }
                      if (done) {
                        return fileArray
                      } else {
                        return reader.read().then(appendStreamChunk)
                      }
                    })
                    .then(async file => {
                      let dirname = ''
                      if (this.tableOptions.checkedRows[row].id_mercury) {
                        dirname = this.tableOptions.checkedRows[row].id_mercury
                      } else {
                        /*if (this.tableOptions.checkedRows[row].primaryCode) {
                          dirname = this.tableOptions.checkedRows[row]
                            .primaryCode;
                        } else {*/
                        dirname = this.tableOptions.checkedRows[row].id
                        //}
                      }
                      zip.file(
                        dirname + '/' + dirname + '_' + item.replace('scan_no_duna_', '') + '.' + oldmeta,
                        file,
                        {
                          createFolders: true,
                        }
                      )
                    })
                    .catch()
                })
              })
            }
          }
        }
      }
      zip.generateAsync({ type: 'blob' }).then(content => {
        saveAs(
          content,
          this.$store.getters.user.userInfo.name +
            this.$store.getters.user.userInfo.surname +
            new Date().toLocaleDateString() +
            '.zip'
        )
      })
      this.tableOptions.loading = false
    },
    searchData() {
      this.tableData = []
      this.tableOptions.loading = true

      //update filters
      this.setFilterValues(
        this.orderTypeFilterInfo.filterValue,
        this.orderTypeMainFilterInfo.filterValue,
        this.deliverySelectedFilterInfo.filterValue,
        this.statusOrderFilterInfo.filterValue,
        this.$store.state.filters.internalOrders.patient,
        this.queryString,
        this.moduleFilterInfo.filterValue
      )

      this.tableOptions.checkedRows = []
      this.mainQuery = this.$db.collection('orders')
      //if (this.$route.params.patientId) {
      if (this.patientFilter) {
        this.mainQuery = this.mainQuery.where(
          'patientId',
          '==',
          this.patientFilter
          //this.$route.params.patientId
        )
      }

      this.mainQuery = this.mainQuery.where('searchArray', 'array-contains', this.queryString.toLowerCase())
      if (this.startdate) {
        this.mainQuery = this.mainQuery.where('send_date', '>=', this.startdate.getTime())
        this.field = null
        this.order = null
        this.$refs.mainTable.currentSortColumn = null
      }
      if (this.enddate) {
        this.mainQuery = this.mainQuery.where('send_date', '<=', this.enddate.getTime() + 1000 * 60 * 60 * 24)
        this.field = null
        this.order = null
        this.$refs.mainTable.currentSortColumn = null
      }
      /*if (this.startdate || this.enddate) {
      }*/
      if (this.orderTypeFilterInfo.filterValue != '*') {
        if (this.orderTypeFilterInfo.filterValue == 'claim') {
          this.mainQuery = this.mainQuery.where('haveclaimsAdmin', '==', true)
        } else {
          if (this.field == 'orderType') {
            this.field = null
            this.order = null
            this.$refs.mainTable.currentSortColumn = null
          }
          this.mainQuery = this.mainQuery.where('orderType', '==', this.orderTypeFilterInfo.filterValue)
        }
      }
      if (this.orderTypeMainFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where('orderTypeMain', '==', this.orderTypeMainFilterInfo.filterValue)
      }
      if (this.deliverySelectedFilterInfo.filterValue != '*') {
        if (this.field == 'deliverySelected') {
          this.field = null
          this.order = null
          this.$refs.mainTable.currentSortColumn = null
        }

        this.mainQuery = this.mainQuery.where('deliverySelected', '==', this.deliverySelectedFilterInfo.filterValue)
      }
      if (this.statusOrderFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('statusOrder', '==', this.statusOrderFilterInfo.filterValue)
      }
      if (this.moduleFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('module', '==', this.moduleFilterInfo.filterValue)
      }

      this.lastRequested = null
      this.shopindex = 0
      this.statusIndex = 0
      this.companiesindex = 0
      this.deliveryindex = 0
      this.orderTypeindex = 0
      this.orderTypeMainindex = 0
      this.appendData()
    },

    createFilters() {
      this.orderTypeFilterInfo.options = [{ name: '*' }]
      this.orderTypeMainFilterInfo.options = [{ name: '*' }]
      this.deliverySelectedFilterInfo.options = [{ name: '*' }]
      this.statusOrderFilterInfo.options = [{ name: '*' }]
      for (let m of this.$modules) {
        if (!this.moduleFilterInfo.options.find(o => o.name === m)) {
          this.moduleFilterInfo.options.push({ name: m })
        }
      }

      this.orderTypeFilterInfo.options.push({ name: 'claim' })

      for (let module of this.$modules) {
        this.$availableOrderType[module].forEach(dictionary => {
          dictionary.variant.forEach(element => {
            if (
              this.orderTypeFilterInfo.options
                .map(e => {
                  return e.name
                })
                .indexOf(element.key) === -1
            ) {
              this.orderTypeFilterInfo.options.push({ name: element.key })
              this.AllorderType.push(element.key)
            }
          })
        })

        this.$availableOrderType[module].forEach(dictionary => {
          if (dictionary.variant) {
            dictionary.variant.forEach(element => {
              if (element.variant) {
                element.variant.forEach(element2 => {
                  if (
                    this.orderTypeMainFilterInfo.options
                      .map(e => {
                        return e.name
                      })
                      .indexOf(element2.key) === -1
                  ) {
                    this.orderTypeMainFilterInfo.options.push({ name: element2.key })
                    this.AllorderTypeMain.push(element2.key)
                  }
                })
              }
            })
          }
        })

        this.$availableDeliveryType[module].forEach(dictionary => {
          dictionary.variant.forEach(element => {
            if (
              this.deliverySelectedFilterInfo.options
                .map(e => {
                  return e.name
                })
                .indexOf(element.key) === -1
            ) {
              this.deliverySelectedFilterInfo.options.push({ name: element.key })
              this.AlldeliverySelected.push(element.key)
            }
          })
        })
      }
      // this.$availableOrderType.forEach(dictionary => {
      //   dictionary.variant.forEach(element => {
      //     if (
      //       this.orderTypeFilterInfo.options
      //         .map(e => {
      //           return e.name
      //         })
      //         .indexOf(element.key) == -1
      //     ) {
      //       this.orderTypeFilterInfo.options.push({ name: element.key })
      //       this.AllorderType.push(element.key)
      //     }
      //   })
      // })

      // this.$availableOrderType.forEach(dictionary => {
      //   dictionary.variant.forEach(element => {
      //     element.variant.forEach(element2 => {
      //       if (
      //         this.orderTypeMainFilterInfo.options
      //           .map(e => {
      //             return e.name
      //           })
      //           .indexOf(element2.key) == -1
      //       ) {
      //         this.orderTypeMainFilterInfo.options.push({ name: element2.key })
      //         this.AllorderTypeMain.push(element2.key)
      //       }
      //     })
      //   })
      // })

      // this.$availableDeliveryType.forEach(dictionary => {
      //   dictionary.variant.forEach(element => {
      //     if (
      //       this.deliverySelectedFilterInfo.options
      //         .map(e => {
      //           return e.name
      //         })
      //         .indexOf(element.key) == -1
      //     ) {
      //       this.deliverySelectedFilterInfo.options.push({ name: element.key })
      //       this.AlldeliverySelected.push(element.key)
      //     }
      //   })
      // })

      this.$status['tailored'].forEach(element => {
        if (
          this.statusOrderFilterInfo.options
            .map(e => {
              return e.name
            })
            .indexOf(element) === -1 &&
          element != 'deletedord'
        ) {
          this.statusOrderFilterInfo.options.push({ name: element })
        }
      })
    },
    loadFilterValues() {
      this.orderTypeFilterInfo.filterValue = this.$store.state.filters.internalOrders.type
      this.orderTypeMainFilterInfo.filterValue = this.$store.state.filters.internalOrders.typeMain
      this.deliverySelectedFilterInfo.filterValue = this.$store.state.filters.internalOrders.delivery
      this.statusOrderFilterInfo.filterValue = this.$store.state.filters.internalOrders.status
      this.patientFilter = this.$store.state.filters.internalOrders.patient
      this.queryString = this.$store.state.filters.internalOrders.text
    },
    setFilterValues(type, typeMain, delivery, status, patient, text, module) {
      this.$store.commit('setFiltersInternalOrders', {
        type: type,
        typeMain: typeMain,
        delivery: delivery,
        status: status,
        patient: patient,
        text: text,
        module: module,
      })
    },
    async loadData() {
      this.tableData = []
      await this.createFilters()

      //set latest filter used
      this.loadFilterValues()

      //if (this.$route.params.patientId) {
      if (this.patientFilter) {
        this.mainQuery = this.mainQuery.where(
          'patientId',
          '==',
          this.patientFilter
          //this.$route.params.patientId
        )
      }

      if (this.queryString) {
        this.mainQuery = this.mainQuery.where('searchArray', 'array-contains', this.queryString.toLowerCase())
      }

      if (this.orderTypeFilterInfo.filterValue !== '*') {
        if (this.orderTypeFilterInfo.filterValue === 'claim') {
          this.mainQuery = this.mainQuery.where('haveclaimsAdmin', '==', true)
        } else {
          if (this.field === 'orderType') {
            this.field = null
            this.order = null
            this.$refs.mainTable.currentSortColumn = null
          }
          this.mainQuery = this.mainQuery.where('orderType', '==', this.orderTypeFilterInfo.filterValue)
        }
      }
      if (this.orderTypeMainFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('orderTypeMain', '==', this.orderTypeMainFilterInfo.filterValue)
      }
      if (this.deliverySelectedFilterInfo.filterValue !== '*') {
        if (this.field === 'deliverySelected') {
          this.field = null
          this.order = null
          this.$refs.mainTable.currentSortColumn = null
        }

        this.mainQuery = this.mainQuery.where('deliverySelected', '==', this.deliverySelectedFilterInfo.filterValue)
      }
      if (this.statusOrderFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('statusOrder', '==', this.statusOrderFilterInfo.filterValue)
      }

      this.appendData()
    },
    appendData(newlimit = this.limit) {
      this.tableOptions.loading = true
      let thisQuery = this.mainQuery

      switch (this.isSwitched) {
        case 0:
          thisQuery = thisQuery.where('deleted', '==', false)
          if (this.userInfo.type === 'I' && this.userInfo.level === '1') {
            thisQuery = thisQuery.where('statusOrder', 'in', this.$statusActiveI12)
          } else {
            thisQuery = thisQuery.where('statusOrder', 'in', this.$statusActive)
          }
          break
        case 1:
          thisQuery = thisQuery.where('deleted', '==', false)
          thisQuery = thisQuery.where('statusOrder', 'in', this.$statusClosed)
          break
        case 2:
          thisQuery = thisQuery.where('deleted', '==', true)
          break
        default:
          thisQuery = thisQuery.where('deleted', '==', false)
          if (this.userInfo.type === 'I' && this.userInfo.level === '1') {
            thisQuery = thisQuery.where('statusOrder', 'in', this.$statusActiveI12)
          } else {
            thisQuery = thisQuery.where('statusOrder', 'in', this.$statusActive)
          }
          break
      }

      if (this.field === 'statusOrder') {
        thisQuery = thisQuery.where('statusOrder', '==', this.AllStatus[this.statusIndex])
      }

      if (this.field === 'deliverySelected') {
        thisQuery = thisQuery.where('deliverySelected', '==', this.AlldeliverySelected[this.deliveryindex])
      }

      if (this.field === 'orderType') {
        thisQuery = thisQuery.where('orderType', '==', this.AllorderType[this.orderTypeindex])
      }

      if (this.field === 'orderTypeMain') {
        thisQuery = thisQuery.where('orderTypeMain', '==', this.AllorderTypeMain[this.orderTypeMainindex])
      }
      if (this.field === 'send_date') {
        thisQuery = thisQuery.orderBy(this.field, this.order)
      } else {
        thisQuery = thisQuery.orderBy('send_date', 'asc')
      }

      if (!this.allCompanies) {
        if (this.allShops) {
          thisQuery = thisQuery.where('company.id', '==', this.companiesId[this.companiesindex])
        } else {
          thisQuery = thisQuery.where('shop.id', '==', this.shopsId[this.shopindex])
        }
      }

      if (this.lastRequested != null) {
        thisQuery = thisQuery.startAt(this.lastRequested)
      }
      thisQuery
        .limit(newlimit + 1)
        .get()
        .then(docs => {
          this.disableRequestMore = docs.size <= newlimit
          let i = 0
          docs.forEach(doc => {
            let newOrder = doc.data()
            newOrder.id = doc.id
            newOrder.module = newOrder.module || 'tailored'
            i++
            if (i <= newlimit) {
              this.tableData.push(newOrder)
              for (let claim in newOrder.claims) {
                if (!newOrder.claims[claim].deleted) {
                  if (
                    (!newOrder.claims[claim].AdminClaim && newOrder.claims[claim].status !== 'saved') ||
                    newOrder.claims[claim].AdminClaim
                  ) {
                    newOrder.claims[claim].id = claim
                    newOrder.claims[claim].orderid = newOrder.id
                    newOrder.claims[claim].shop = newOrder.shop
                    newOrder.claims[claim].primaryCode =
                      newOrder.primaryCode + '_CLAIM_' + ('0000' + (parseInt(claim) + 1)).substr(-4, 4)
                    if (newOrder.claims[claim].answer) {
                      newOrder.claims[claim].primaryCode = 'R_' + newOrder.claims[claim].primaryCode
                    }
                    newOrder.claims[claim].orderType = 'CLAIM'
                    newOrder.claims[claim].claim = true
                    newOrder.claims[claim].send_date = newOrder.claims[claim].creationDate
                    if (newOrder.claims[claim].status !== 'confirmed') {
                      this.tableData.push(newOrder.claims[claim])
                    }
                  }
                }
              }
            }
            this.lastRequested = doc
          })
          if (
            this.disableRequestMore &&
            (this.shopsId.length > this.shopindex + 1 || this.companiesId.length > this.companiesindex + 1)
          ) {
            this.shopindex += 1
            this.companiesindex += 1
            this.lastRequested = null
            this.appendData(newlimit - docs.size)
          } else {
            if (
              this.disableRequestMore &&
              this.field === 'statusOrder' &&
              this.AllStatus.length > this.statusIndex + 1
            ) {
              this.shopindex = 0
              this.companiesindex = 0
              this.statusIndex += 1

              this.lastRequested = null
              this.appendData(newlimit - docs.size)
            } else {
              if (
                this.disableRequestMore &&
                this.field === 'deliverySelected' &&
                this.AlldeliverySelected.length > this.deliveryindex + 1
              ) {
                this.shopindex = 0
                this.companiesindex = 0
                this.deliveryindex += 1

                this.lastRequested = null
                this.appendData(newlimit - docs.size)
              } else {
                if (
                  this.disableRequestMore &&
                  this.field === 'orderTypeMain' &&
                  this.AllorderTypeMain.length > this.orderTypeMainindex + 1
                ) {
                  this.shopindex = 0
                  this.companiesindex = 0
                  this.orderTypeMainindex += 1

                  this.lastRequested = null
                  this.appendData(newlimit - docs.size)
                } else {
                  if (
                    this.disableRequestMore &&
                    this.field === 'orderType' &&
                    this.AllorderType.length > this.orderTypeindex + 1
                  ) {
                    this.shopindex = 0
                    this.companiesindex = 0
                    this.orderTypeindex += 1

                    this.lastRequested = null
                    this.appendData(newlimit - docs.size)
                  } else {
                    this.tableOptions.loading = false
                  }
                }
              }
            }
          }
        })
    },
    isTrackingNumberDisabled() {
      if (this.userInfo.type == 'A') {
        if (this.hasSameStatus()) {
          return false
        } else {
          return true
        }
      } else {
        if (this.hasSameStatus('courier') || this.hasSameStatus('closed')) {
          return false
        } else {
          return true
        }
      }
    },
    hasSameStatus(status = undefined) {
      if (this.tableOptions.checkedRows.length === 0) return false
      if (!status) {
        status = this.tableOptions.checkedRows[0].statusOrder
      }
      let isStatusDifferent = false
      this.tableOptions.checkedRows.forEach(order => {
        if (!order.claim && order.statusOrder !== status) {
          isStatusDifferent = true
        }
      })
      return !isStatusDifferent
    },
    checkIfSendable() {
      if (this.statusSelected !== 'compord' && this.statusSelected !== 'deletedord') {
        let areSendable = true
        this.tableOptions.checkedRows.forEach(order => {
          //if (!this.isSendable(order)) {
          //areSendable = false
          //}
          if (!this.checkSend(order)) {
            areSendable = false
          }
        })
        if (!areSendable) {
          this.$buefy.dialog.alert({
            title: this.$options.filters.capitalize(this.$translate('error')),
            message: this.$options.filters.capitalize(this.$translate('changeStatusNotPermitted')),
            type: 'is-danger',
            hasIcon: true,
            icon: 'alert',
            ariaRole: 'alertdialog',
            ariaModal: true,
          })
        }
        return areSendable
      } else {
        return true
      }
    },
    checkIfSendablewithParameter(statusString) {
      if (statusString !== 'compord' && statusString !== 'deletedord') {
        let areSendable = true
        this.tableOptions.checkedRows.forEach(order => {
          //if (!this.isSendable(order)) {
          //areSendable = false
          //}
          if (!this.checkSend(order)) {
            areSendable = false
          }
        })
        if (!areSendable) {
          this.$buefy.dialog.alert({
            title: this.$options.filters.capitalize(this.$translate('error')),
            message: this.$options.filters.capitalize(this.$translate('changeStatusNotPermitted')),
            type: 'is-danger',
            hasIcon: true,
            icon: 'alert',
            ariaRole: 'alertdialog',
            ariaModal: true,
          })
        }
        return areSendable
      } else {
        return true
      }
    },

    changeStatus(newStatus = this.statusSelected) {
      //Se l'aggiornamento batch dovesse non andare a buon fine devo fare il revert degli ordini
      const cloneDeep = require('clone-deep')
      this.oldOrders = cloneDeep(this.tableOptions.checkedRows)
      //Se posso aggiornare lo stato lo faccio
      //Altrimenti avverto che non è stato possibile cambiare stato
      if (this.changeGroupStatus(this.tableOptions.checkedRows, newStatus)) {
        //creo un update batch che contiene gli ordini aggiornati
        let batch = this.$db.batch()
        this.tableOptions.checkedRows.forEach(order => {
          let orderref = this.$db.collection('orders').doc(order.id)
          batch.update(orderref, order)
        })
        //eseguo la chiamata batch
        batch
          .commit()
          .then(() => {
            switch (this.isSwitched) {
              case 1:
                if (!this.$statusClosed.includes(newStatus)) {
                  this.tableOptions.checkedRows.forEach(row => {
                    this.tableData.splice(this.tableData.indexOf(row), 1)
                  })
                }
                break
              case 2:
                if (newStatus !== 'deletedord') {
                  this.tableOptions.checkedRows.forEach(row => {
                    this.tableData.splice(this.tableData.indexOf(row), 1)
                  })
                }
                break
              default:
                if (this.userInfo.type === 'I' && this.userInfo.level === '1') {
                  if (!this.$statusActiveI12.includes(newStatus)) {
                    this.tableOptions.checkedRows.forEach(row => {
                      this.tableData.splice(this.tableData.indexOf(row), 1)
                    })
                  }
                } else {
                  if (!this.$statusActive.includes(newStatus)) {
                    this.tableOptions.checkedRows.forEach(row => {
                      this.tableData.splice(this.tableData.indexOf(row), 1)
                    })
                  }
                }
                break
            }
            //se va a buon fine avverto e tolgo le spunte
            this.tableOptions.checkedRows = []
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('success_form'),
              type: 'is-success',
            })
          })
          .catch(() => {
            //se non dovesse andare a buon fine faccio il revert con i vecchi ordini
            this.tableOptions.checkedRows = this.oldOrders
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('failed_form'),
              type: 'is-danger',
            })
          })
      } else {
        this.$buefy.dialog.alert({
          title: this.$options.filters.capitalize(this.$translate('error')),
          message: this.$options.filters.capitalize(this.$translate('changeStatusNotPermitted')),
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert',
          ariaRole: 'alertdialog',
          ariaModal: true,
        })
      }
    },
    markAsPrinted() {
      const orders = this.tableOptions.checkedRows.filter(order => !order.claim)
      if (orders.length === 0) return
      const batch = this.$db.batch()
      orders.forEach(order => {
        batch.update(this.$db.collection('orders').doc(order.id), { isPrinted: true })
      })
      batch
        .commit()
        .then(() => {
          orders.forEach(order => {
            this.$set(order, 'isPrinted', true)
          })
          this.tableOptions.checkedRows = []
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
        })
        .catch(() => {
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        })
    },
    groupChangeStatuswithPrameters(statusString) {
      if (this.hasSameStatus() && this.checkIfSendablewithParameter(statusString)) {
        {
          this.tableOptions.checkedRows.forEach(order => {
            this.$db
              .collection('orders')
              .doc(order.id)
              .update({ statusOrder: statusString })
              .then(() => {
                order.statusOrder = statusString
              })
          })
        }
      }
    },
    groupChangeStatus() {
      if (this.hasSameStatus() && this.checkIfSendable()) {
        {
          var batch = this.$db.batch()
          let newStatus = {}
          let newsend_date = {}
          let deletedarray = {}

          this.tableOptions.checkedRows.forEach(order => {
            newsend_date[order] = order.send_date
            if (this.statusSelected !== 'compord' && this.statusSelected !== 'invord' && order.send_date == null) {
              newsend_date[order] = new Date().getTime()
            }
            newStatus[order] = this.statusSelected
            if (order.statusOrder == 'sendord' && this.statusSelected == 'proc_order') {
              if (this.isWaitForMaterialsOrder()) {
                newStatus[order] = 'waitord'
              }
            }
            if (newStatus[order] == 'deletedord') {
              deletedarray[order] = true
            } else {
              deletedarray[order] = false
            }
            //! deve diventare operazione batch?SI
            /*this.$db
              .collection("orders")
              .doc(order.id)
              .update({ statusOrder: newStatus })
              .then(() => {
                order.statusOrder = newStatus;
              });
            */

            //carico il batch con lo status
            var orderref = this.$db.collection('orders').doc(order.id)
            batch.update(orderref, {
              statusOrder: newStatus[order],
              send_date: newsend_date[order],
              deleted: deletedarray[order],
              lastModificationDate: new Date().getTime(),
              history: firebase.firestore.FieldValue.arrayUnion({
                technician: this.$store.getters.user.userInfo.username,
                date: new Date().getTime(),
                oldStatus: order.statusOrder,
                newStatus: newStatus[order],
              }),
            })
          })

          batch
            .commit()
            .then(() => {
              this.tableOptions.checkedRows.forEach(order => {
                if (!order.history) {
                  order.history = []
                }
                order.history.push({
                  technician: this.$store.getters.user.userInfo.username,
                  date: new Date().getTime(),
                  oldStatus: order.statusOrder,
                  newStatus: newStatus[order],
                })
                order.statusOrder = newStatus[order]
                order.send_date = newsend_date[order]
              })
              this.tableOptions.checkedRows = []
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_form'),
                type: 'is-success',
              })
            })
            .catch(() => {
              //console.log(error);
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('failed_form'),
                type: 'is-danger',
              })
            })
        }
      }
    },
    updateSearchArray(order) {
      let searchArray = this.generateArrayFromOrder(order)
      this.$db
        .collection('orders')
        .doc(order.id)
        .update({
          searchArray: searchArray,
        })
        .then(() => {
          order.searchArray = searchArray
        })
    },
    massiveUpdateSearchArray() {
      for (let order of this.tableOptions.checkedRows) {
        let searchArray = this.generateArrayFromOrder(order)
        this.$db
          .collection('orders')
          .doc(order.id)
          .update({
            searchArray: searchArray,
          })
          .then(() => {
            order.searchArray = searchArray
          })
      }
    },
    massivechangeTrack() {
      this.massivetrackingmodal = false
      for (let order in this.massivecurrentorderid) {
        this.$db
          .collection('orders')
          .doc(this.massivecurrentorderid[order].id)
          .update({
            track_number: this.newtrack_number,
          })
          .then(() => {
            this.massivecurrentorderid[order].track_number = this.newtrack_number
          })
      }
    },
    massiveChangeDeliveryDate() {
      this.massiveDeliveryDateModal = false
      for (let order in this.massivecurrentorderid) {
        if (this.massivecurrentorderid[order].tempDeliveryDate) {
          this.$db
            .collection('orders')
            .doc(this.massivecurrentorderid[order].id)
            .update({
              deliveryDate: this.massivecurrentorderid[order].tempDeliveryDate.getTime(),
            })
            .then(() => {
              this.massivecurrentorderid[order].deliveryDate = this.massivecurrentorderid[order].tempDeliveryDate
              this.$forceUpdate()
            })
        }
      }
    },
    massivechangeMercurioid() {
      this.massivemercurioidmodal = false
      for (let order in this.massivecurrentorderid) {
        let searchArray = this.generateKeyWord([
          this.massivecurrentorderid[order].patient.alias,
          this.massivecurrentorderid[order].patient.name + ' ' + this.massivecurrentorderid[order].patient.surname,
          this.massivecurrentorderid[order].primaryCode,
          this.massivecurrentorderid[order].tempid_mercury ? this.massivecurrentorderid[order].tempid_mercury : '',
          this.massivecurrentorderid[order].company.name,
          this.massivecurrentorderid[order].shop.name,
          this.massivecurrentorderid[order].tec,
        ])
        this.$db
          .collection('orders')
          .doc(this.massivecurrentorderid[order].id)
          .update({
            id_mercury: this.massivecurrentorderid[order].tempid_mercury
              ? this.massivecurrentorderid[order].tempid_mercury
              : '',
            searchArray: searchArray,
          })
          .then(() => {
            this.massivecurrentorderid[order].id_mercury = this.massivecurrentorderid[order].tempid_mercury
            this.$forceUpdate()
          })
      }
    },
    trackcodechangemodal() {
      this.massivecurrentorderid = []
      this.tableOptions.checkedRows.forEach(row => {
        if (!row.claim) {
          if (this.userInfo.type === 'C' && row.statusOrder === 'invord') {
            this.massivecurrentorderid.push(row)
          } else {
            if (
              this.userInfo.type === 'C' &&
              this.userInfo.level !== 1 &&
              (row.statusOrder === 'invord' || row.statusOrder === 'waitord')
            ) {
              this.massivecurrentorderid.push(row)
            } else {
              if (this.userInfo.type === 'I' && (row.statusOrder === 'courier' || row.statusOrder === 'closed')) {
                this.massivecurrentorderid.push(row)
              } else {
                if (this.userInfo.type === 'A') {
                  this.massivecurrentorderid.push(row)
                }
              }
            }
          }
        }
      })
      if (this.massivecurrentorderid.length > 0) {
        this.massivetrackingmodal = true
      }
    },
    massiveDeliveryDateChangeModal() {
      this.massivecurrentorderid = []
      this.tableOptions.checkedRows.forEach(row => {
        if (!row.claim) {
          //console.log(row.send_date);
          //console.log(row.deliveryDate);
          row.tempDeliveryDate = row.deliveryDate ? new Date(row.deliveryDate) : null
          this.massivecurrentorderid.push(row)
        }
      })
      if (this.massivecurrentorderid.length > 0) {
        this.massiveDeliveryDateModal = true
      }
    },
    massivemercurioidchangemodal() {
      this.massivecurrentorderid = []
      this.tableOptions.checkedRows.forEach(row => {
        if (!row.claim) {
          row.tempid_mercury = row.id_mercury
          this.massivecurrentorderid.push(row)
        }
      })
      if (this.massivecurrentorderid.length > 0) {
        this.massivemercurioidmodal = true
      }
    },
    mercurioidchangemodal(currentrow) {
      this.massivecurrentorderid = []
      if (currentrow.id != 0) {
        currentrow.tempid_mercury = currentrow.id_mercury
        this.massivecurrentorderid.push(currentrow)
        this.massivemercurioidmodal = true
      }
    },
    deleteOccurenceClaim(orderid, idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('claim_message_confirm'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('claim_message_destroy'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection('orders')
            .doc(orderid)
            .get()
            .then(doc => {
              let order = doc.data()
              order.claims[idtoerase].deleted = true
              order.haveclaimsAdmin = false
              order.haveclaimsCustomer = false
              for (let index in order.claims) {
                if (!order.claims[index].deleted && !order.claims[index].confirmed) {
                  if (order.claims[index].status !== 'saved') {
                    order.haveclaimsAdmin = true
                    order.haveclaimsCustomer = true
                  } else {
                    if (this.claim.AdminClaim) {
                      order.haveclaimsAdmin = true
                    } else {
                      order.haveclaimsCustomer = true
                    }
                  }
                }
              }
              this.$db
                .collection('orders')
                .doc(orderid)
                .update({
                  statusOrder: order.claims[idtoerase].originalStatus,
                  claims: order.claims,
                  haveclaimsCustomer: order.haveclaimsCustomer,
                  haveclaimsAdmin: order.haveclaimsAdmin,
                })
                .then(() => {
                  this.searchData()
                  this.$buefy.notification.open({
                    duration: 3000,
                    message: this.$translate('success_delete'),
                  })
                })
            }),
      })
    },
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('order_message_confirm'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('order_message_destroy'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection('orders')
            .doc(idtoerase)
            .set(
              {
                statusOrder: 'deletedord',
                deleted: true,
              },
              { merge: true }
            )
            .then(() => {
              this.searchData()
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            }),
      })
    },
    async exportJsonArray() {
      await this.exportOrdersJson(this.tableOptions.checkedRows)
    },
    async sendJsonArrayToMercurio() {
      this.tableOptions.loading = true
      await this.sendOrdersToMercurio(this.tableOptions.checkedRows)
      this.tableOptions.loading = false
    },
  },
}
</script>
<style scoped>
.container >>> .table-footer td {
  color: #bdbdbd;
}

@media only screen and (min-width: 1280px) {
  .container >>> .b-table .table th {
    font-weight: 600;
    position: sticky;
    top: 120px;
    background: white;
    z-index: 8;
  }

  .first-level {
    height: 60px;
    background: white;
    top: 0px;
    position: sticky;
    z-index: 9;
    margin-top: 0;
    margin-bottom: 0;
  }

  .second-level {
    height: 60px;
    background: white;
    top: 60px;
    position: sticky;
    z-index: 8;
    margin-top: 0;
    margin-bottom: 0;
  }
  .container >>> .dropdown-menu {
    z-index: 5;
  }
  .container >>> .label {
    white-space: nowrap;
  }
}
</style>
